import Swiper from "swiper";
import {Pagination, Navigation, EffectCreative, Controller} from "swiper/modules";

const swiperButtonHeight = 51;

function setCarouselButtonsPosition(swiperID, imageHeight) {
    document
        .querySelector(`#${swiperID} ~ .swiper-button-next`)
        .style.setProperty("top", `${imageHeight / 2 - swiperButtonHeight / 2}px`, "important");
    document.querySelector(`#${swiperID} ~ .swiper-button-next`).style.setProperty("margin-top", `0px`, "important");
    document
        .querySelector(`#${swiperID} ~ .swiper-button-prev`)
        .style.setProperty("top", `${imageHeight / 2 - swiperButtonHeight / 2}px`, "important");
    document.querySelector(`#${swiperID} ~ .swiper-button-prev`).style.setProperty("margin-top", `0px`, "important");
}

// Drugi tipi sob carousel
export function swiperDrugiTipiSobInit() {
    const swipers = document.querySelectorAll(".js-swiper-drugi-tipi-sob");

    swipers.forEach((swiper) => {
        let swiperID = swiper.id;

        if (!swiperID) {
            // console.log("tole se izvede ker ni nastavljen ID");
            swiperID = `keks${(Math.random() + 1).toString(36).substring(7)}`;
            swiper.id = swiperID;
        }

        const counterCurrent = document.querySelector(`#${swiperID} ~ .col.order-3 .image-slider__current`);
        const counterTotal = document.querySelector(`#${swiperID} ~ .col.order-3 .image-slider__total`);

        // eslint-disable-next-line
        const carousel = new Swiper(swiper, {
            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                    spaceBetween: 16,
                },
                576: {
                    slidesPerView: 2.15,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 2.15,
                    spaceBetween: 32,
                },
            },
            pagination: {
                el: `#${swiperID} ~ .col.order-3 .swiper-pagination.swiper-pagination-drugi-tipi-sob`,
                type: "progressbar",
            },
            on: {
                afterInit() {
                    counterTotal.innerHTML = `${this.slides.length}`;
                },
                slideChange: () => {
                    counterCurrent.innerHTML = `${carousel.realIndex + 1}`;
                },
            },
            navigation: {
                nextEl: `#${swiperID} ~ .swiper-button-next.swiper-buttons-drugi-tipi-sob`,
                prevEl: `#${swiperID} ~ .swiper-button-prev.swiper-buttons-drugi-tipi-sob`,
            },
            modules: [Pagination, Navigation],
        });
    });
}

// Področja carousel
export function swiperPodrocjaInit() {
    const swipers = document.querySelectorAll(".js-swiper-podrocja");

    swipers.forEach((swiper) => {
        let swiperID = swiper.id;

        if (!swiperID) {
            // console.log("tole se izvede ker ni nastavljen ID");
            swiperID = `keks${(Math.random() + 1).toString(36).substring(7)}`;
            swiper.id = swiperID;
        }

        // eslint-disable-next-line no-unused-vars
        const carousel = new Swiper(swiper, {
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 0,
                },
                1024: {
                    slidesPerView: 1.3,
                    spaceBetween: 0,
                },
            },
            speed: 600,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: false,
                    translate: ["-95%", 0, -700],
                },
                next: {
                    shadow: false,
                    translate: ["95%", 0, -700],
                },
            },
            on: {
                afterInit() {
                    const image = swiper.querySelector(".swiper-slide img.media");
                    let imageHeight;

                    if (!image.complete) {
                        image.addEventListener("load", () => {
                            imageHeight = image.offsetHeight;
                            setCarouselButtonsPosition(swiperID, imageHeight);
                        });
                    }

                    // Backup position setter
                    setTimeout(() => {
                        imageHeight = image.offsetHeight;
                        setCarouselButtonsPosition(swiperID, imageHeight);
                    }, 1000);

                    window.addEventListener("resize", () => {
                        imageHeight = image.offsetHeight;
                        setCarouselButtonsPosition(swiperID, imageHeight);
                    });
                },
            },
            navigation: {
                nextEl: ".swiper-button-next.swiper-buttons-podrocja",
                prevEl: ".swiper-button-prev.swiper-buttons-podrocja",
            },
            modules: [Navigation, EffectCreative],
        });
    });
}

export function swiperVsebinskiIzpostavekInit() {
    const swipersContainer = document.querySelectorAll(".carousel-vsebinski-izpostavek");

    swipersContainer.forEach((element) => {
        let swiperID = element.id;

        if (!swiperID) {
            // console.log("tole se izvede ker ni nastavljen ID");
            swiperID = `keks${(Math.random() + 1).toString(36).substring(7)}`;
            element.id = swiperID;
        }

        const swiperImage = element.querySelector(".js-swiper-vsebinski-izpostavek");
        const swiperText = element.querySelector(".js-swiper-vsebinski-izpostavek-text");

        const counterCurrent = element.querySelector(".image-slider__current");
        const counterTotal = element.querySelector(".image-slider__total");

        const carouselImage = new Swiper(swiperImage, {
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 0,
                },
            },
            speed: 600,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: false,
                    translate: ["-95%", 0, -700],
                },
                next: {
                    shadow: false,
                    translate: ["95%", 0, -700],
                },
            },
            pagination: {
                el: `#${swiperID} .swiper-pagination.swiper-pagination-vsebinski-izpostavek`,
                type: "progressbar",
            },
            navigation: {
                nextEl: `#${swiperID} .swiper-button-next.swiper-buttons-vsebinski-izpostavek`,
                prevEl: `#${swiperID} .swiper-button-prev.swiper-buttons-vsebinski-izpostavek`,
            },
            on: {
                afterInit() {
                    counterTotal.innerHTML = `${this.slides.length}`;
                },
                slideChange: () => {
                    counterCurrent.innerHTML = `${carouselImage.realIndex + 1}`;
                },
            },
            modules: [Pagination, Navigation, EffectCreative, Controller],
            watchSlidesProgress: true,
            autoHeight: true,
        });

        const carouselText = new Swiper(swiperText, {
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 600,
            modules: [Controller],
            autoHeight: true,
        });

        carouselImage.controller.control = carouselText;
        carouselText.controller.control = carouselImage;
    });
}

// Okolica carousel
export function swiperOkolicaInit() {
    const swipers = document.querySelectorAll(".js-swiper-okolica");

    swipers.forEach((swiper) => {
        let swiperID = swiper.id;

        if (!swiperID) {
            // console.log("tole se izvede ker ni nastavljen ID");
            swiperID = `keks${(Math.random() + 1).toString(36).substring(7)}`;
            swiper.id = swiperID;
        }

        const counterCurrent = document.querySelector(`#${swiperID} ~ .col.order-3 .image-slider__current`);
        const counterTotal = document.querySelector(`#${swiperID} ~ .col.order-3 .image-slider__total`);
        // eslint-disable-next-line no-unused-vars
        const carousel = new Swiper(swiper, {
            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                    spaceBetween: 16,
                },
                576: {
                    slidesPerView: 2.15,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 2.15,
                    spaceBetween: 32,
                },
            },
            on: {
                afterInit() {
                    counterTotal.innerHTML = `${this.slides.length}`;
                },
                slideChange: () => {
                    counterCurrent.innerHTML = `${carousel.realIndex + 1}`;
                },
            },
            pagination: {
                el: `#${swiperID} ~ .col.order-3 .swiper-pagination.swiper-pagination-okolica`,
                type: "progressbar",
            },
            navigation: {
                nextEl: `#${swiperID} ~  .swiper-button-next.swiper-buttons-okolica`,
                prevEl: `#${swiperID} ~  .swiper-button-prev.swiper-buttons-okolica`,
            },
            modules: [Pagination, Navigation],
        });
    });
}

// Trip advisor carousel
export function swiperTestemonialsInit() {
    const swipers = document.querySelectorAll(".js-swiper-testemonials");

    swipers.forEach((swiper) => {
        let swiperID = swiper.id;

        if (!swiperID) {
            // console.log("tole se izvede ker ni nastavljen ID");
            swiperID = `keks${(Math.random() + 1).toString(36).substring(7)}`;
            swiper.id = swiperID;
        }

        // eslint-disable-next-line no-unused-vars
        const carousel = new Swiper(swiper, {
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                1024: {
                    slidesPerView: 2,
                },
            },
            pagination: {
                el: `#${swiperID} .swiper-pagination.swiper-pagination-testemonials`,
                type: "progressbar",
            },
            navigation: {
                nextEl: `#${swiperID} .swiper-button-next.swiper-buttons-testemonials`,
                prevEl: `#${swiperID} .swiper-button-prev.swiper-buttons-testemonials`,
            },
            modules: [Pagination, Navigation],
        });
    });
}

// Paketi in akcije carousel
export function swiperPaketiInAkcijeInit() {
    const swipers = document.querySelectorAll(".js-swiper-paketi-in-akcije");

    swipers.forEach((swiper) => {
        // eslint-disable-next-line no-unused-vars
        const carousel = new Swiper(swiper, {
            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                    spaceBetween: 16,
                },
                576: {
                    slidesPerView: 2.15,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
        });
    });
}

// IP ponudba carousel
export function swiperIpPonudbaInit() {
    const swipers = document.querySelectorAll(".js-swiper-ip-ponudba");

    swipers.forEach((swiper) => {
        let carousel;
        const countAllSlides = swiper.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;

        let swiperID = swiper.id;

        if (!swiperID) {
            // console.log("tole se izvede ker ni nastavljen ID");
            swiperID = `keks${(Math.random() + 1).toString(36).substring(7)}`;
            swiper.id = swiperID;
        }

        // eslint-disable-next-line prefer-const, no-unused-vars
        carousel = new Swiper(swiper, {
            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                    spaceBetween: 24,
                },
                576: {
                    slidesPerView: 2.15,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 3.15,
                    spaceBetween: 32,
                },
            },
            on: {
                // eslint-disable-next-line
                init: function (sw) {
                    document.querySelector(".image-slider__total.image-slider__total-ip-ponudba").textContent = countAllSlides;
                    document.querySelector(".image-slider__current.image-slider__current-ip-ponudba").textContent = sw.realIndex + 1;
                },
                // eslint-disable-next-line
                slideChange: function (sw) {
                    document.querySelector(".image-slider__current.image-slider__current-ip-ponudba").textContent = sw.realIndex + 1;
                },
            },
            pagination: {
                el: `#${swiperID} ~ .swiper-pagination.swiper-pagination-ip-ponudba`,
                type: "progressbar",
            },
            navigation: {
                nextEl: `#${swiperID} ~  .swiper-button-next.swiper-buttons-ip-ponudba`,
                prevEl: `#${swiperID} ~  .swiper-button-prev.swiper-buttons-ip-ponudba`,
            },
            modules: [Pagination, Navigation],
        });
    });
}

// Dogodki carousel
export function swiperDogodkiInit() {
    const swipers = document.querySelectorAll(".js-swiper-dogodki");

    swipers.forEach((swiper) => {
        let carousel;
        const countAllSlides = swiper.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;
        // try to center navigation buttons to the center of the image vertically

        let swiperID = swiper.id;

        if (!swiperID) {
            // console.log("tole se izvede ker ni nastavljen ID");
            swiperID = `keks${(Math.random() + 1).toString(36).substring(7)}`;
            swiper.id = swiperID;
        }

        // eslint-disable-next-line prefer-const, no-unused-vars
        carousel = new Swiper(swiper, {
            breakpoints: {
                0: {
                    slidesPerView: 1.15,
                    spaceBetween: 24,
                },
                576: {
                    slidesPerView: 2.15,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
            on: {
                // eslint-disable-next-line
                init: function (sw) {
                    let image = swiper.querySelector(".swiper-slide img.media");
                    let imageHeight = image.offsetHeight;
                    document.querySelector(".image-slider__total.image-slider__total-dogodki").textContent = countAllSlides;
                    document.querySelector(".image-slider__current.image-slider__current-dogodki").textContent = sw.realIndex + 1;
                    setCarouselButtonsPosition(swiperID, imageHeight);
                    window.addEventListener("resize", () => {
                        image = swiper.querySelector(".swiper-slide img.media");
                        imageHeight = image.offsetHeight;
                        setCarouselButtonsPosition(swiperID, imageHeight);
                    });
                },
                // eslint-disable-next-line
                slideChange: function (sw) {
                    document.querySelector(".image-slider__current.image-slider__current-dogodki").textContent = sw.realIndex + 1;
                },
            },
            pagination: {
                el: `#${swiperID} ~ .swiper-pagination.swiper-pagination-dogodki`,
                type: "progressbar",
            },
            navigation: {
                nextEl: `#${swiperID} ~ .swiper-button-next.swiper-buttons-dogodki`,
                prevEl: `#${swiperID} ~ .swiper-button-prev.swiper-buttons-dogodki`,
            },
            modules: [Pagination, Navigation],
        });
    });
}

// USP kartice carousel
export function swiperUspKarticeInit() {
    const swipers = document.querySelectorAll(".js-swiper-usp-kartice");

    swipers.forEach((swiper) => {
        let swiperID = swiper.id;

        if (!swiperID) {
            // console.log("tole se izvede ker ni nastavljen ID");
            swiperID = `keks${(Math.random() + 1).toString(36).substring(7)}`;
            swiper.id = swiperID;
        }
        // eslint-disable-next-line
        const carousel = new Swiper(swiper, {
            breakpoints: {
                0: {
                    slidesPerView: 1.25,
                    spaceBetween: 16,
                },
                576: {
                    slidesPerView: 3.25,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 4.25,
                    spaceBetween: 32,
                },
            },
            pagination: {
                el: `#${swiperID} ~ .swiper-pagination.swiper-pagination-usp-kartice`,
                type: "progressbar",
            },
            modules: [Pagination, Navigation],
        });
    });
}

// Kongresi in srečanja carousel
export function swiperKongresiInSrecanjaInit() {
    const swipers = document.querySelectorAll(".js-swiper-kongresi-in-srecanja");

    swipers.forEach((swiper, index) => {
        let carousel;
        const countAllSlides = swiper.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;

        let swiperID = swiper.id;

        if (!swiperID) {
            // console.log("tole se izvede ker ni nastavljen ID");
            swiperID = `keks${(Math.random() + 1).toString(36).substring(7)}`;
            swiper.id = swiperID;
        }

        // eslint-disable-next-line
        carousel = new Swiper(swiper, {
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 24,
                },
                576: {
                    slidesPerView: 1.8,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 1.5,
                    spaceBetween: 32,
                },
            },
            on: {
                // eslint-disable-next-line
                init: function (sw) {
                    document.querySelector(`.image-slider__total.image-slider__total-kongresi-in-srecanja-${index}`).textContent = countAllSlides;
                    document.querySelector(`.image-slider__current.image-slider__current-kongresi-in-srecanja-${index}`).textContent =
                        sw.realIndex + 1;
                },
                // eslint-disable-next-line
                slideChange: function (sw) {
                    document.querySelector(`.image-slider__current.image-slider__current-kongresi-in-srecanja-${index}`).textContent =
                        sw.realIndex + 1;
                },
            },
            pagination: {
                el: `#${swiperID} .swiper-pagination.swiper-pagination-kongresi-in-srecanja`,
                type: "progressbar",
            },
            navigation: {
                nextEl: `#${swiperID} .swiper-button-next.swiper-buttons-kongresi-in-srecanja`,
                prevEl: `#${swiperID} .swiper-button-prev.swiper-buttons-kongresi-in-srecanja`,
            },
            modules: [Pagination, Navigation],
        });
    });
}
